module.exports = __webpack_public_path__ + "img/phone-small.21d4d27c.svg";